import { render, staticRenderFns } from "./SearchOverlay.vue?vue&type=template&id=6ca06a12&scoped=true"
import script from "./SearchOverlay.vue?vue&type=script&lang=js"
export * from "./SearchOverlay.vue?vue&type=script&lang=js"
import style0 from "./SearchOverlay.vue?vue&type=style&index=0&id=6ca06a12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca06a12",
  null
  
)

export default component.exports